import { render } from "./projectsSlide3.vue?vue&type=template&id=339284dc&scoped=true"
import script from "./projectsSlide3.vue?vue&type=script&lang=js"
export * from "./projectsSlide3.vue?vue&type=script&lang=js"

import "./projectsSlide3.vue?vue&type=style&index=0&id=339284dc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339284dc"]])

export default __exports__